import { IMcqPayload, IQuestionPayload } from "../../types";
import { request } from "../../utils/axios";

export const createMcq = async (form: IMcqPayload) => {
  try {
    const res = await request.post(`admin/mcqs`, form);
    return res?.data;
  } catch (error: any) {
    const err = error?.response;
    throw err;
  }
};

export const updateMcq = async (form: IMcqPayload) => {
  try {
    const res = await request.put(`admin/mcqs/${form.id}`, form);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchMcq = async (page = 1) => {
  try {
    const res = await request.get(`admin/mcqs?page=${page}`);
    return res?.data?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchSingleMcq = async (id: number) => {
  try {
    const res = await request.get(`admin/mcqs/${id}`);
    return res?.data?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const deleteMcq = async (id: number) => {
  try {
    const res = await request.delete(`admin/mcqs/${id}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

//QUESTIONS

export const createQuestion = async (form: IQuestionPayload) => {
  try {
    const res = await request.post(`admin/mcqs/${form.mcq_id}/questions`, form);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const updateQuestion = async (form: IQuestionPayload) => {
  try {
    const res = await request.put(
      `admin/mcqs/${form.mcq_id}/questions/${form.ID}`,
      form
    );
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchQuestions = async () => {
  try {
    const res = await request.get(`admin/mcqs/:id/questions/:questionId`);
    return res?.data?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const deleteQuestion = async ({
  questionId,
  mcqId,
}: {
  questionId: number;
  mcqId: number;
}) => {
  try {
    const res = await request.delete(
      `admin/mcqs/${mcqId}/questions/${questionId}`
    );
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};
